import type { OptionType } from '@/types'

import type {
  StockImportConfigShortModel,
  StoreModel,
} from '../../types/stockImports.types'

type StoreOptionsParams = {
  stores: StoreModel[]
  configs: StockImportConfigShortModel[]
  isSelfSupplierMode: boolean
  supplierId: string
  excludeConfigIds: Array<string | undefined>
  originalStoreId: string | undefined
}

export type StoreOptionsResult = {
  options: OptionType[]
  storesWithConfig: Set<string>
  mismatchedStore: StoreModel | null
}

export const buildConfigStoreOptions = ({
  stores,
  configs,
  isSelfSupplierMode,
  supplierId,
  excludeConfigIds,
  originalStoreId,
}: StoreOptionsParams): StoreOptionsResult => {
  const storesWithConfig = new Set(
    configs.flatMap((item) =>
      item.status !== 'ARCHIVED' &&
      !excludeConfigIds.includes(item.id) &&
      item.store?.id
        ? [item.store.id]
        : []
    )
  )
  const relevantStores =
    !isSelfSupplierMode && supplierId
      ? stores.filter(
          (store) => store.productSupplierShortDto?.id === supplierId
        )
      : stores
  const mismatchedStore =
    originalStoreId &&
    !relevantStores.some((store) => store.id === originalStoreId)
      ? (stores.find((store) => store.id === originalStoreId) ?? null)
      : null

  const options: OptionType[] = relevantStores.map((store) => ({
    value: store.id,
    label: store.description,
    disabled: storesWithConfig.has(store.id),
  }))
  if (mismatchedStore)
    options.unshift({
      value: mismatchedStore.id,
      label: mismatchedStore.description,
      disabled: true,
    })

  return { options, storesWithConfig, mismatchedStore }
}
